import { render, staticRenderFns } from "./ModalAccountSetting.vue?vue&type=template&id=30dd3bda&"
import script from "./ModalAccountSetting.vue?vue&type=script&lang=js&"
export * from "./ModalAccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports